import { Video as VideoType } from 'app/blocks/video'
import React from 'react'

import VideoPlayer from 'app/components/primitive/VideoPlayer'
import { VideoPlayerRef } from 'app/components/primitive/VideoPlayer/useVideoPlayerControls'

export interface VideoBlockProps {
  title?: string
  thumbnail?: string
  block: VideoType
  isUnlocked: boolean
  onVideoPlay?: () => void
  onVideoPause?: () => void
  onVideoEnd?: () => void
  onVideoProgress?: (progress: number) => void
  muted?: boolean
  autoplay?: boolean
  /** Ref to control the video player */
  playerRef?: React.RefObject<VideoPlayerRef>
}

export const VideoBlock: React.FC<VideoBlockProps> = ({
  block,
  muted = false,
  autoplay = false,
  playerRef,
  ...rest
}) => {
  const data = JSON.parse(block.videoData)
  return (
    <VideoPlayer
      ref={playerRef}
      id={block.id}
      url={block.video}
      player={block.player}
      data={data}
      captions={block.closedCaptions}
      muted={muted}
      autoplay={autoplay}
      {...rest}
    />
  )
}
